export default __webpack_public_path__ + "static/DF_2019-6fd4d3bcd4707e6d54f10f8de0493a98.pdf";